import {
  EMAIL_VALIDATOR,
  NAME_VALIDATOR,
  PHONE_VALIDATOR,
  LENGTH_VALIDATOR,
  MIN_VALIDATOR,
  ZIP_CODE_VALIDATOR,
  PASSWORD_VALIDATOR,
} from "../../messages/errorsMessages";

export const nameValidator = (required: boolean) => ({
  required,
  pattern: {
    value: /^[A-ZĄĆĘŁŃÓŚŹŻ]+([a-ząćęłńóśźż]*)+[\s][A-ZĄĆĘŁŃÓŚŹŻ]+[a-ząćęłńóśźż]*$/,
    message: NAME_VALIDATOR,
  },
});

export const phoneValidator = (required: boolean) => ({
  required,
  pattern: {
    value: /(([+][0-9]{2}[.-]?)?[0-9]{3}([.-]?)[0-9]{3}([.-]?)[0-9]{3})|^$/,
    message: PHONE_VALIDATOR,
  },
});

export const emailValidator = (required: boolean) => ({
  required,
  pattern: {
    value: /(^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$)|^$/,
    message: EMAIL_VALIDATOR,
  },
});

export const lengthValidator = (required: boolean, minLength: number) => ({
  required,
  minLength: {
    value: minLength,
    message: LENGTH_VALIDATOR(minLength),
  },
});

export const minValue = (required: boolean, min: number) => ({
  required,
  min: {
    value: min,
    message: MIN_VALIDATOR(min),
  },
});

export const zipCodeValidator = (required: boolean) => ({
  required,
  pattern: {
    value: /\d{2}-\d{3}/,
    message: ZIP_CODE_VALIDATOR,
  },
});

export const passValidator = (required: boolean) => ({
  required,
  pattern: {
    value: /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,64}$/,
    message: PASSWORD_VALIDATOR,
  },
});
